import script from "./DayResultsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DayResultsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./DayResultsPanel.vue?vue&type=style&index=0&id=82f8fc90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82f8fc90"]])

export default __exports__